import { toTypedSchema } from "@vee-validate/zod"
import type { MaybeRef } from "@vueuse/core"
import { useForm } from "vee-validate"
import z from "zod"
import { unref } from "vue"
import type {
  TypedSchemaInput,
  TypedSchemaOutput,
} from "@/utils/typeUtilities"
import { trimmedString } from "@/forms/validation/stringFieldSchemas"

const configureOrderFormSchema = z.object({
  note: trimmedString(),
  serviceChargePercentage: z.number().max(100).min(0),
  serviceChargeFlat: z.number().min(0),
})

export type ConfigureOrderFormInput = TypedSchemaInput<
  typeof configureOrderFormSchema
>

export type ConfigureOrderFormOutput = TypedSchemaOutput<
  typeof configureOrderFormSchema
>

export const useConfigureOrderForm = (
  initialValues: MaybeRef<ConfigureOrderFormInput>
) =>
  useForm({
    validationSchema: toTypedSchema(
      configureOrderFormSchema
    ),
    initialValues: unref(initialValues),
  })
